export default __webpack_public_path__ + "static/media/logo_suzukirentacar_hokkaido.fc014744.svg";